import navigate from './navigate';

const actions = {
  navigate,
};

export default actions;
